
export default {
  async created () {
    const messages = { // keep this out of callbacks https://github.com/kazupon/vue-i18n/issues/184
      fiveMin: this.$t('5 minutes remaining!'),
      bookingResumed: this.$t('Booking resumed!'),
      bookingPaused: this.$t('Booking is paused!'),
    };
    this.$store.watch((state, getters) => getters.remainingTime, (current, old) => {
      if (['infinite', 'offline'].includes(this.$store.getters.timerStatus)) return;
      if (current < (5 * 60 * 1000) && old > (5 * 60 * 1000) && this.$store.getters.timerStatus === 'active') {
        if (current < (4.5 * 60 * 1000)) return; // ensure this warning is not displayed if booking time changed from 5min+ to 4min-
        this.$store.dispatch('addNotification', {
          props: {
            message: messages.fiveMin,
          },
        });
      }
      const timeDiff = current - old;
      if (timeDiff > (1 * 60 * 1000)) {
        this.$store.dispatch('notifyTimesAdded', timeDiff);
      }
    });
    this.$store.watch((state, getters) => getters.timerStatus, (current, old) => {
      if (current === 'active' && old === 'paused') {
        this.$store.dispatch('addNotification', {
          props: {
            message: messages.bookingResumed,
          },
        });
      }
      if (current === 'paused' && old === 'active') {
        this.$store.dispatch('addNotification', {
          props: {
            message: messages.bookingPaused,
          },
        });
      }
    });
  },
};
